<template>
  <div class="content main-container">
    <div class="search-box ivu-form">
      <div class="input-item">
        <span class="label">结算报表名称</span>
        <Input v-model="searchParams.reportName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" clearable>
          <Option value="0">待结算</Option>
          <Option value="1">已结算</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="handleSearch()">查询</Button>
        <Button type="primary" ghost @click="handleReset()">重置</Button>
      </div>
    </div>
    <Tabs v-model="activeTab" :animated="false" @on-click="handleTabChange">
      <TabPane label="基本法" name="basic">
        <basicTab ref="basicTab" />
      </TabPane>
      <TabPane label="周边收支与佣金调整" name="extra">
        <extraTab ref="extraTab" />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import basicTab from './components/basicTab';
import extraTab from './components/extraTab';

const DEFAULT_SEARCH_PARAMS = {
  reportName: '',
  settlementDate: [],
  settlementStatus: ''
};

export default {
  name: 'BasicLaw',
  components: {
    basicTab,
    extraTab
  },
  data() {
    return {
      activeTab: 'basic',
      searchParams: { ...DEFAULT_SEARCH_PARAMS }
    };
  },
  methods: {
    getActiveTabRef() {
      return this.activeTab === 'basic' ? this.$refs.basicTab : this.$refs.extraTab;
    },
    handleSearch() {
      const tab = this.getActiveTabRef();
      tab.searchParams = { ...this.searchParams };
      tab.searchAjax();
    },
    handleReset() {
      this.searchParams = { ...DEFAULT_SEARCH_PARAMS };
      const tab = this.getActiveTabRef();
      tab.searchParams = { ...DEFAULT_SEARCH_PARAMS };
      tab.searchParamsOrigin = { ...DEFAULT_SEARCH_PARAMS };
      tab.searchAjax();
    },
    handleTabChange() {
      this.$nextTick(() => {
        const tab = this.getActiveTabRef();
        tab.searchParams = { ...this.searchParams };
        tab.searchParamsOrigin = { ...this.searchParams };
        tab.getList();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  padding-right: 270px;
}
</style>
